interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
  sx?: any
}

export default function TabPanel(props: TabPanelProps) {
  const { children, sx, value, index, ...other } = props;

  return (
    <div
      style={sx}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <>{children}</>}
    </div>
  );
}
